import React, { useEffect, useState } from 'react'
import Navbar from '../Components/Core/Navbar.jsx';
import { useNavigate } from 'react-router-dom'
import Footer from '../Components/Core/Footer.jsx';
import '../Styles/CartPage/Cart.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelopeOpen, faRotateLeft } from '@fortawesome/free-solid-svg-icons'
import api from '../api.js';
import { Check } from 'react-feather';
import { showToast } from '../Components/PopupMessage.jsx';
import FullscreenSpinner from '../Components/FullscreenSpinner.jsx';

function Checkout() {
    const [cartList, setCartList] = useState([]);
    const [subtotal, setSubtotal] = useState('');
    const [tax, setTax] = useState('');
    const [total, setTotal] = useState('');
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [addressId, setAddressId] = useState(null);
    const [addressList, setAddressList] = useState([]);
    const [paymentMethod, setPaymentMethod] = useState(null);
    const [coupon_discount, setCoupon_discount] = useState(null);
    // const [subtotalDiscount, setSubtotalDiscount] = useState(null);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState("");
    const [couponCode, setCouponCode] = useState(null);

    const [first_name, setFirst_name] = useState("");
    const [last_name, setLast_name] = useState("");
    const [number, setNumber] = useState("");
    const [city, setCity] = useState("");
    const [address, setAddress] = useState("");
    const [state, setState] = useState("");
    const [post_code, setPost_code] = useState("");
    const [paymentmode, setPaymentmode] = useState("COD");

    const accessToken = localStorage.getItem('accessToken');
    const navigate = useNavigate();
    const [addresses, setAddresses] = useState(false);

    const [switches, setSwitches] = useState(true);
    const [tracking_id, setTracking_id] = useState(null);
    const [network, setNetwork] = useState(true);



    const handleCoupon = async (e) => {
        if (!couponCode) {
            alert("Please enter a coupon code.");
            return;
        }
        e.preventDefault();


        try {
            setNetwork(true);
            const response = await api.get(`/user_api/checkout/get-checkout-details?access_token=${JSON.parse(accessToken)}&coupon_code=${couponCode}`);
            // console.log(response.data.message);

            if (response.data.status === "success") {
                setData(response.data);
                setCoupon_discount(response.data.coupon_discount)
                // setSubtotalDiscount(response.data.subtotal_discount);

                
                showToast("Coupon Applied Successfully", "success");
                setNetwork(false);
            }


        } catch (error) {
            console.error('Error applying coupon:', error);
            showToast("Error applying coupon. Please try again.", "error");
        }

    }
    const handlePlaceOrder = async () => {
        if (!selectedAddress) {
            alert("Please select an address before placing the order.");
            setNetwork(false);
            return;
        }
        if (!paymentMethod) {
            alert("Please select a payment method before placing the order.");
            setNetwork(false);
            return;
        }



        try {
            
            const response = await api.post("/user_api/checkout/place-cod-order", {
                address_id: addressId,
                payment_mode: paymentMethod,
                coupon_code: couponCode || null,
                coupon_discount: coupon_discount || null,
                access_token: JSON.parse(accessToken),
                subtotal: subtotal,
                totalTax: tax,
                grand_total: total,
                totalDiscount: null,


            });

            if (response.data.status === "success") {
                setTracking_id(response.data.tracking_no)
                showToast(response.data.message, "success");
                navigate(`/successfullyorderplaced/${response.data.tracking_no}`);
                
            } else {
                // alert("placed nehi hua");
                alert(response.data.message);
            }

        } catch (error) {
            console.error('Error placing order:', error);
            setLoading(false);
        }
    }


    const handleclick = () => {
        setSwitches(false);
        setAddresses(true);
    }
    const addnewaddress = () => {
        setSwitches(false);

    }
    const handleSavedAddress = () => {
        setSwitches(true);

    }

    console.log("accesstoken: ", JSON.parse(accessToken));
    useEffect(() => {
        if (switches) {
            const callAddressApi = async () => {
                try {
                    setNetwork(true);
                    const response = await api.get(`/user_api/checkout/get-checkout-details?access_token=${JSON.parse(accessToken)}`);
                    if (response.data.status === "success") {
                        setAddressList(response.data.address);
                        setSelectedAddress(response.data.address[0]);
                        console.log("Fetched address list after switching to saved addresses", response.data.address);
                        setNetwork(false);
                    }
                    else {
                        alert(response.data.message);
                    }

                } catch (error) {
                    console.error('Error fetching saved addresses:', error);
                    // alert("try block main galat hai .")
                }
            };
            callAddressApi();
        }
    }, [switches]);




    const handleaddress = async (e) => {
        e.preventDefault();


        setLoading(true);
        const formData = {
            first_name,
            last_name,
            number,
            address,
            city,
            state,
            post_code
        };
        try {
            const response = await api.post(`/user_api/checkout/post-address?access_token=${JSON.parse(accessToken)}`, formData);
            console.log(response.data.message);
            setLoading(false);
            // alert(response.data.message);
            if (response.data.message === "Address has been saved successfully") {
                showToast(response.data.message, "success");
                setSwitches(true);
            }



        } catch (error) {
            showToast("Error adding address. Please try again.", "error");
            console.error('Error adding address:', error);
            setLoading(false);
        }
    }


    useEffect(() => {

        const getCartList = async () => {

            try {
               
                const response = await api.get(
                    `user_api/checkout/get-checkout-details?access_token=${JSON.parse(
                        accessToken
                    )}`
                );
                if (response.data.status === "failed") {
                    showToast("Your cart is empty. Please add items to your cart.", "info");
                    navigate("/");
                }
                if (response.data.status === "success") {
                    setData(response.data);
                    setSubtotal(response.data.subtotal);
                    setTax(response.data.total_tax);
                    setCartList(response?.data?.product);
                    setTotal(response?.data?.grand_total);
                    setAddressList(response.data.address);
                    console.log("addressList", response.data.address);
                    console.log(accessToken);
                    console.log("addressList", response.data.message);
                    setNetwork(false);
                }


            } catch (error) {
                console.log('Error fetching cart:', error);
                showToast("Error fetching Items. Please try again.", "error");
                setNetwork(false);
            }
        };
        getCartList();

    }, [])
    const handlecheckout = () => {
        setAddresses(false);
        console.log("addressID: ", addressId);
        const selected = addressList.find((item) => item.id === addressId);
        setSelectedAddress(selected);
        console.log("Selected Address:", selected);
    }
    const handleCanceladdress = () => {
        setAddresses(false);
    }



    return (
        <>
         {network && <FullscreenSpinner/>}
            {addresses &&
                (
                    <div className='overlay'>
                        <div className='addresspage_container'>
                            <div className='addresspage_header'>
                                <span onClick={handleSavedAddress} style={{ width: "50%", fontSize: "16px" }}>Saved Addresses:</span>
                                <span className='add_new_address' style={{ width: "50%", fontSize: "16px" }} onClick={addnewaddress}>+Add New Address</span>
                            </div>

                            {switches ? (
                                <>

                                    <div style={{ display: "flex", flexDirection: "column", gap: "10px", position: "relative", overflowY: "auto", maxHeight: "500px", paddingRight: "10px" }} >

                                        {addressList.map((item) => (
                                            <div className='default_address' key={item.id} >
                                                <span style={{ display: "flex", alignItems: "center", justifyContent: "center", textAlign: "center" }}>
                                                    <input type='radio' id='radio_id' value={item.id} checked={addressId === item.id} onChange={() => setAddressId(item.id)} />
                                                </span>

                                                <span className='address_name'>
                                                    <span>{item.first_name}</span>
                                                    <span>{item.number}</span>
                                                    <span className='address_name_main'> {item.address},{item.city},{item.post_code},{item.state}</span>
                                                </span>
                                            </div>
                                        ))}


                                    </div>
                                    <button className="btn btn-success btn-lg btn-block checkout_down_button" type="submit" onClick={handlecheckout}>
                                        Continue to checkout
                                    </button>

                                </>
                            ) : (
                                <>
                                    <form className="needs-validation" >
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="firstName" >First name</label>
                                                <input type="text" className="form-control" id="firstName" required value={first_name} onChange={(e) => setFirst_name(e.target.value)} />
                                                <div className="invalid-feedback">Valid first name is required.</div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="lastName" >Last name</label>
                                                <input type="text" className="form-control" id="lastName" required value={last_name} onChange={(e) => setLast_name(e.target.value)} />
                                                <div className="invalid-feedback">Valid last name is required.</div>
                                            </div>
                                        </div>

                                        <div className="mb-1">
                                            <label htmlFor="username">Number</label>
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">+971</span>
                                                </div>
                                                <input type="text" className="form-control" id="username" placeholder="Enter Phone Number" required value={number} onChange={(e) => setNumber(e.target.value)} />
                                                <div className="invalid-feedback" style={{ width: "100%" }}>
                                                    Your username is required.
                                                </div>
                                            </div>
                                        </div>


                                        <div className="mb-1">
                                            <label htmlFor="address">Address</label>
                                            <input type="text" className="form-control" id="address" placeholder="1234 Main St" required value={address} onChange={(e) => setAddress(e.target.value)} />
                                        </div>

                                        <div className="row">
                                            <div className="col-md-5 mb-1">
                                                <label htmlFor="country">State</label>
                                                <input className="form-control" id="country" required value={state} onChange={(e) => setState(e.target.value)} />


                                            </div>
                                            <div className="col-md-4 mb-1">
                                                <label htmlFor="state">City</label>
                                                <input type='text' className=" form-control" id="state" required value={city} onChange={(e) => setCity(e.target.value)} />


                                            </div>
                                            <div className="col-md-3 mb-2">
                                                <label htmlFor="zip">Pin</label>
                                                <input type="text" className="form-control" id="zip" required value={post_code} onChange={(e) => setPost_code(e.target.value)} />
                                            </div>
                                        </div>

                                        {/* <hr className="mb-4" /> */}
                                        {/* <div className="custom-control custom-checkbox">
                                            <input type="checkbox" className="custom-control-input" id="same-address" />
                                            <label className="custom-control-label" htmlFor="same-address">
                                                Shipping address is the same as my billing address
                                            </label>
                                        </div> */}
                                        {/* <div className="custom-control custom-checkbox">
                                            <input type="checkbox" className="custom-control-input" id="save-info" />
                                            <label className="custom-control-label" htmlFor="save-info">
                                                Save this information for next time
                                            </label>
                                        </div> */}

                                        {/* <hr className="mb-4" /> */}
                                        <button className="btn btn-success btn-lg btn-block checkout_down_button w-100 mb-2" type="submit" onClick={handleaddress}>
                                            Save Address
                                        </button>
                                        <button className="btn btn-warning btn-lg btn-block checkout_down_button w-100" type="submit" onClick={handleCanceladdress}>
                                            Cancel
                                        </button>
                                    </form>
                                </>
                            )}
                        </div>
                    </div>
                )}

            {/* Main Page Content */}
            <Navbar />

            <div className='cart_items_parent_div'>

                <div className='cart_items_div'>
                    {/* Product cards */}
                    {cartList.map((item, index) => (
                        <div className="cart_item_container shadow">
                            <div className="cart_item_img_div" style={{}}>
                                <img
                                    src={item.product_image_path}

                                    style={{ border: "0.5px solid #ccc", padding: "3px", borderRadius: "10px", height: "100%", width: "100%" }}
                                />
                            </div>
                            <div className="cart_item_Details_div">
                                <div className="cart_item_name_div">
                                    <h5>{item.product_name}</h5>
                                </div>
                                {/* <div className='cart_item_price_div'>
                      <p className='Short_description'>this is a Product Description part this is product details part</p>
                    </div> */}
                                <div className="cart_item_price_div" style={{ display: "flex", gap: "4px", alignItems: "center" }}>
                                    <p
                                        style={{

                                            fontWeight: "600",
                                            marginBottom: "0px",
                                            marginLeft: "0px"
                                        }}
                                        className="cart_item_price"
                                    >
                                        AED {item.total_price}
                                    </p>
                                    <p
                                        style={{

                                            textDecoration: "line-through",
                                            marginBottom: "0px",
                                        }}
                                        className="cart_item_initial_price"
                                    >
                                        {item.initial_cost}
                                    </p>
                                    <p
                                        style={{

                                            color: "green",
                                            marginBottom: "0px",
                                        }}
                                        className="cart_item_discount"
                                    >
                                        {item.discout}% off
                                    </p>

                                </div>

                                <div className="cart_item_remove_div">
                                    <div style={{ display: "flex", gap: "2px" }}><span style={{ fontWeight: "600" }}>Quantity:</span><span>{item.quantity}</span></div>
                                    <div style={{ display: "flex", gap: "4px" }}>
                                        <label style={{ fontWeight: "600" }}>Attribute: </label>
                                        <span >{item.attribute}</span>
                                    </div>
                                    <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
                                        <label style={{ fontWeight: "600" }}>Color: </label>
                                        <span style={{ backgroundColor: `#${item.color}`, borderRadius: "100%", border: "0.5px solid #CCC" }} className="colour_design"></span>
                                    </div>

                                </div>

                            </div>
                        </div>
                    ))}



                </div>

                {/* Right Price Panel */}
                <div style={{ paddingLeft: "4px", }} className='cart_items_Price_div'>
                    <div className='cart_items_Price_list '>
                        {/* Coupon Section */}

                        <div className='coupon_section'>
                            <div className='coupon_header_name'>COUPON</div>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
                                    <FontAwesomeIcon icon={faEnvelopeOpen} color='orange' /><span>Apply Coupon</span>
                                </div>

                                <button className='apply_coupon_button' style={{ borderRadius: "5px" }} onClick={handleCoupon}>Apply</button>
                            </div>
                            <div style={{ width: "100%" }}><input type='text' placeholder='Enter the Coupon Code here...' style={{ width: "100%", padding: "5px 10px" }} value={couponCode} onChange={(e) => setCouponCode(e.target.value)} required /></div>
                            <hr style={{ marginTop: "0px" }} />
                        </div>


                        {/* Address Part */}
                        <div className='address_part'>

                            <div >
                                {selectedAddress ?

                                    <div >

                                        <div className='address_header'>
                                            <span>Delivery to: </span>
                                            <span className='ADD_ADDRESS' onClick={handleclick}>Change Address</span>
                                        </div>

                                        <div className='default_address'>
                                            <span style={{ display: "flex", alignItems: "center" }}>
                                                <input type='radio' id='radio_id' checked={addressId === selectedAddress.id} onChange={() => setAddressId(selectedAddress.id)} />
                                            </span>
                                            <span className='address_name' style={{ display: "flex", flexWrap: "wrap", padding: "3px", flexDirection: "column", gap: "1px" }}>
                                                <span style={{ display: "flex", gap: "1px" }}><span> {selectedAddress.first_name}</span>{selectedAddress.last_name}<span></span></span>
                                                <span>{selectedAddress.number}</span>
                                                <span>{selectedAddress.address},{selectedAddress.city},{selectedAddress.post_code},{selectedAddress.state}</span>

                                            </span>
                                        </div>
                                    </div>
                                    : <button className='btn btn-primary w-100' onClick={handleclick}>+ADD ADDRESS</button>}

                            </div>



                        </div>

                        {/* Billing Details */}
                        {data && (
                            <div className='Product_bill_details'>
                                <div className='Product_bill_details_header'>PRODUCT BILL DETAILS</div>
                                <div className='Product_bill_details_div'>
                                    <div className='Product_bill_details_name'>Subtotal</div>
                                    <div className='Product_bill_details_price'>AED {data.subtotal}</div>
                                </div>
                                <div className='Product_bill_details_div'>
                                    <div className='Product_bill_details_name'>Shipping</div>
                                    <div className='Product_bill_details_price'>AED 00.00</div>
                                </div>
                                <div className='Product_bill_details_div'>
                                    <div className='Product_bill_details_name'>Coupon Discount</div>
                                    <div className='Product_bill_details_price'>AED {data.coupon_discount}</div>
                                </div>
                                <div className='Product_bill_details_div'>
                                    <div className='Product_bill_details_name'>Tax</div>
                                    <div className='Product_bill_details_price'>AED {data.total_tax}</div>
                                </div>
                                <hr style={{ margin: "0px" }} />
                                <div className='Product_bill_details_div'>
                                    <div className='Product_bill_details_name'>Total</div>
                                    <div className='Product_bill_details_price'>AED {data.grand_total}</div>
                                </div>
                            </div>

                        )}


                        <div>
                            <div className='payment_method_div' style={{ marginBottom: "20px" }}>
                                <div className='payment_method_header' style={{ fontWeight: "bold" }}>Payment Method</div>
                                <div className='payment_method_list'>
                                    <div className='payment_method_item' onClick={() => setPaymentMethod("COD")} style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                        <input type="radio" name="paymentMethod" value="COD" checked={paymentMethod === "COD"} onChange={(e) => setPaymentMethod(e.target.value)} />
                                        <span>Cash on Delivery</span>
                                    </div>
                                    {/* <div className='payment_method_item' onClick={() => setPaymentMethod("Online")}>
                                    <input type="radio" name="paymentMethod" value="Online" checked={paymentMethod === "Online"} onChange={(e) => setPaymentMethod(e.target.value)} />
                                    <span>Online Payment</span>
                                </div> */}
                                </div>
                            </div>
                        </div>



                        {/* Place Order Button */}
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <button className='place_order_btn' onClick={handlePlaceOrder}>Place Order</button>
                        </div>

                    </div>
                </div>
            </div>

            <Footer />
        </>
    )
}

export default Checkout